import { GLogger } from "./logr.develop";
import { IGLoggerStatic } from "./common";

declare global {
    interface Window {
        GLogger: IGLoggerStatic;
        IS_DEVELOP: boolean;
        IS_DEBUG: boolean;
    }
}

// IS_DEVELOP je nastavený natvrdo, IS_DEBUG se může měnit
Object.defineProperties(window, {
    IS_DEVELOP: {
        configurable: false
        , enumerable: true
        , value: true
        , writable: false
    }
    , IS_DEBUG: {
        configurable: false
        , enumerable: true
        , value: false
        , writable: true
    }
});

window.GLogger = GLogger;




// WEBPACK FOOTER //
// ./index.develop.ts